import React from "react";
import { content } from "../../data";
import { Icon } from "@iconify/react";
import Copyrights from "../Copyrights/Copyrights";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";

const Footer = () => {
  const navItems = content.navItems;

  const handleScroll = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex justify-center bg-black w-full h-auto xl:h-[80px]">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 w-full">
        {/* Copyright */}
        <div className="!self-center place-self-center xl:place-self-start order-3 xl:order-1 md:col-span-2 xl:col-span-1 lg:pl-10 py-4">
          <Copyrights />
        </div>

        {/* footer Nav */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-5 w-fit place-self-center order-1 xl:order-2 pt-8 pb-6 xl:py-0">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              onClick={handleScroll}
              className="text-white hover:text-orange transition"
            >
              <StyledMdText>{item.title}</StyledMdText>
            </a>
          ))}
        </div>

        {/* Follow Buttons */}
        <div className="flex justify-center items-center gap-6 bg-green w-full xl:w-[307px] h-full py-3 lg:place-self-end order-2 xl:order-3">
          <StyledH6Heading font="text-black">Follow us:</StyledH6Heading>

          {/* Social Icons */}
          <div className="flex items-center gap-5">
            <a href="https://telegram.org/">
              <Icon icon="cib:telegram-plane" width="30" height="30" />
            </a>
            <a href="https://twitter.com/">
              <Icon icon="pajamas:twitter" width="27" height="27" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
